import { AnalyticsListener as AkAnalyticsListener } from '@atlaskit/analytics-next';
import { getMergedMarketplaceContext, SCREEN_EVENT_TYPE } from '@atlassian/mpac-analytics';
import * as React from 'react';
import { sendEvent, sendPageViewEvent } from '../../../../analytics/Send';
import { getNonScreenEvent, getScreenViewEvent } from '../../../../utils/analytics-utils';
export const ALLOWED_CHANNELS = new Set(['marketplace']);
export function AppInstallAnalyticsListener(props) {
  const onEvent = (event, channel) => {
    const gasEvent = event;
    if (channel && ALLOWED_CHANNELS.has(channel)) {
      const {
        payload,
        context
      } = gasEvent;
      const marketplaceContext = getMergedMarketplaceContext(context);
      if (payload.eventType.type === SCREEN_EVENT_TYPE) {
        const screenEventPayload = payload;
        const finalEvent = getScreenViewEvent({
          marketplaceContext,
          payload: screenEventPayload
        });
        return sendPageViewEvent(finalEvent);
      }
      const nonScreenEventPayload = payload;
      const eventArgs = {
        marketplaceContext,
        payload: nonScreenEventPayload
      };
      const finalEvent = getNonScreenEvent(eventArgs);
      sendEvent(finalEvent);
    }
  };
  return /*#__PURE__*/React.createElement(AkAnalyticsListener, {
    channel: "marketplace",
    onEvent: onEvent
  }, props.children);
}